import { useState, useEffect } from 'react';

const Accordion = ({ items }) => {
  const [openIndices, setOpenIndices] = useState([]);

  useEffect(() => {
    const defaultTitles = ["Property Basic Info", "Address Info" , "Apartment Info" ,"Villa Info" , "Layout Info" , "Basic Info" ,"Dimension (in feet)", "Documents" , "More Info", "Media Info"];
    const defaultIndices = items
      .map((item, index) => (defaultTitles.includes(item.title) ? index : null))
      .filter(index => index !== null);
  
    setOpenIndices(defaultIndices);
    
  }, []); 
  

  const toggleAccordion = (index) => {
    setOpenIndices((prev) =>
      prev.includes(index)
        ? prev.filter(i => i !== index) 
        : [...prev, index] 
    );
  };

  return (
    <div className="w-full space-y-2">
      {items.map((item, index) => (
        <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
          <button
            className={`flex items-center justify-between w-full p-4 text-left transition-colors ${
              openIndices.includes(index) ? 'bg-gray-50' : 'bg-white hover:bg-gray-50'
            }`}
            onClick={() => toggleAccordion(index)}
          >
            <span className="text-lg font-medium text-customGreen">{item.title}</span>
            <svg
              className={`w-5 h-5 text-gray-500 transform transition-transform duration-200 ${
                openIndices.includes(index) ? 'rotate-180' : ''
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </button>
          <div
            className={`overflow-hidden transition-all duration-300 ${
              openIndices.includes(index) ? 'max-h-full' : 'max-h-0'
            }`}
          >
            <div className="p-4 bg-white z-10 border-t border-gray-200">
              {item.content}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
